import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { GeoPoint } from '@common/model/location/geopoint';
import { GeoPointDTO } from '@common/model/location/geopointDTO';

export const getResumeGeoPoint = (model: CatalogItemViewModel): GeoPoint | undefined => {
  let location: GeoPointDTO | undefined;

  if (model.location) {
    location = model.location;
  } else if (model.clientProfile && model.clientProfile.location) {
    location = model.clientProfile.location;
  } else if (model.city) {
    location = model.city.centerPoint;
  }
  return location ? GeoPoint.fromDTO(location) : undefined;
};
